module.exports = __webpack_public_path__ + "static/media/arrows-alt-v.f5ee3168.svg";